export enum LanguagesTypes {
	ES = 'ES',
	EN = 'EN',
	PT = 'PT',
}
